module.exports = __webpack_public_path__ + "img/CeltCapTechGoldRush.0f14db08.webp";